import { storeStructure } from '../store/reducers';
import stepsLive from './formGroupLiveSteps/formGroup0LiveSteps';
import formGroup1Status from './formGroupLiveSteps/formGroupStep5Status/formGroup1Status';

export default {
  title: 'Live event Edit',
  attributeName:'live',
  createURL: 'live',
  sessionParams: [],
  getURL: 'live',
  updateURL: 'live',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: true,
  formConfig: [
    formGroup1Status,
  ],
  forceChangedWhen: {
  field: 'status_live',
  value: 'draft_template',
  },
  stepConfig: stepsLive,
  websocketNavigation:'users_navigation',
  //navigationBlockReaders:true,

  saveIdSessionNameAs: 'liveId',
  websocketChannel: 'liveEdit-liveId',
  websocketSessionParams: ['liveId'],
  websocketItems:['status_live','status_cloud','status_ingest','globalLive']

};
